import type { Vehicle, VehicleDocIssue } from '../api/types';
import { localName } from './format';

/** Mandatory documents that block a new trip on this vehicle today: missing ones and expired mandatory ones. */
export function blockingDocs(v: Vehicle | undefined | null): VehicleDocIssue[] {
  const d = v?.documents;
  if (!d) return [];
  return [...(d.missing ?? []), ...(d.expired ?? []).filter((x) => x.mandatory !== false)];
}

/** Document names in the UI language (falls back to the Ukrainian name the API always sends). */
export function docNames(list: VehicleDocIssue[], locale: string): string {
  return list.map((x) => localName(x.names, locale) || x.name).join(', ');
}

/** Today's date (YYYY-MM-DD) in the phone's own time zone — not UTC, so after local midnight it is already the new day. */
export function localDateInput(d = new Date()): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}
